module.exports = __webpack_public_path__ + "img/logo.5a5cf3f6.png";